module.exports = __webpack_public_path__ + "static/media/icon_T3.ea8da1d8.svg";